(function () {
  'use strict';

  angular.module('app').component('transportationPage', transportationDetailCtrl());

  function transportationDetailCtrl() {
    return {
      bindings: {},
      controller: TransportationDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/transportation/transportation-page.component.html',
    };
  }

  TransportationDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'SessionService',
    'TransportationService',
    'LanguageService',
  ];

  function TransportationDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    SessionService,
    TransportationService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_transportation_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    // Methods
    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Initializers
    // getTransportation();
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getTransportation();
      });
    }

    function getTransportation() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        TransportationService.getTransportation(itemId, {
          lang: vm.defaultLanguage,
          show_contents: true,
        }).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/transportation/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/transportation');
    }
  }
})();
